<template>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h2 class="mb-4">{{__('lang.shoppingcart.modal.configuration.exit.title')}}</h2>
      <form class="needs-validation" method="post" novalidate="novalidate">
        <p class="alert alert-danger">{{__('lang.shoppingcart.modal.configuration.confirm.close')}}</p>
        <div class="form-row my-4">
          <div class="form-group col-12 col-md-3 order-2 order-md-1">
            <button id="closeModal" class="btn btn-gray-50 text-white btn-block" type="reset" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>{{__('lang.btn.cancel')}}
            </button>
          </div>
          <div class="form-group col-12 col-md-4 order-1 order-md-2">
            <button class="btn btn-gray-70 btn-block border-0" type="submit" @click.prevent="close">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>{{__('lang.shoppingcart.modal.configuration.btn.close')}}
            </button>
          </div>
           <div class="form-group col-12 col-md-5 order-1 order-md-2">
              <button class="btn btn-primary btn-block border-0" type="submit" @click.prevent="saveandclose">
                <svg class="icon">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>{{ __('lang.shoppingcart.modal.configuration.btn.save') }}
              </button>
            </div>
        </div>
      </form>
    </div>
  </div>
</div>
</template>



<script>
   
    export default {
        props:['shoppingcart_item'],
        computed: {
          
        },
        data() {
          return {
           
          }
		    },
        methods: {  
          saveandclose:function(){
           

           /*  save , reset and exit:*/
            this.$parent.$refs.shoppingcartsave.updateConfiguration()
            this.$store.dispatch('alert/setAlert', { type: 'success', message: this.__('lang.alert.shoppingcart.configuration.store_configuration_success') }) 
            setTimeout(() => {
              this.$parent.resetConfiguration()
              document.getElementById('closeModalConfigurationReset').click();
            },4000)

            
          },
          close: function () {
            /*  save , reset and exit:
            this.$parent.$refs.shoppingcartsave.updateConfiguration()
            this.$store.dispatch('alert/setAlert', { type: 'success', message: this.__('lang.alert.shoppingcart.configuration.store_configuration_success') }) 
            setTimeout(() => {
              this.$parent.resetConfiguration()
              document.getElementById('closeModalConfigurationReset').click();
            },4000)*/

            /*  dont save, reset and exit:*/
            setTimeout(() => {
              this.$parent.resetConfiguration()
              document.getElementById('closeModalConfigurationReset').click();
            })

          },

        },
        mounted () {
        },
        created() {
         
        },
       /*
        watch: {
          selectedcategories:{
            handler: function(){
              this.storeCategories();
            },
            deep:true //You need to set deep to true when watching an array or object so that Vue knows that it should watch the nested data for changes.
          }
        }
        */
        
       
        


       
    }
  

</script>